import {NarrowPage} from "../../elements/Pages";
import React, {useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useQuery} from "@tanstack/react-query";
import {TextArea} from "../../elements/forms/Inputs";
import Form, {baseHandleChange} from "../../elements/forms/Form";
import {FormSectionContent} from "../../elements/forms/FormLayout";
import {getBook, postBookCodes} from "../../../api/books";

export default function BookImportCodes() {
    const {id} = useParams();
    const navigate = useNavigate();

    const [data, setData] = useState({
        codes: null
    });
    const [errors, setErrors] = useState({});

    const {data: book} = useQuery(['books', id], () => getBook(id), {refetchInterval: 1000 * 60 * 60 * 24});

    const schema = {};

    async function onSave() {
        await postBookCodes(id, data);
    }

    function handleChange(evt) {
        baseHandleChange(evt, data, setData, errors, setErrors, schema);
    }

    const title = `Codes importieren ${book?.title}`

    return (
        <NarrowPage title={title}>

            <Form id="bookImportCodesForm" onSave={onSave}
                  data={data} setData={setData}
                  errors={errors} setErrors={setErrors}
                  successMessage={''}
                  schema={schema}
            >
                <FormSectionContent>
                    <TextArea
                        path="codes"
                        label="Codes"
                        className="sm:col-span-6"
                        onChange={handleChange}
                        errors={errors}
                        data={data}
                        helpText="Codes hier einfügen, getrennt durch Komma, Leerzeichen oder jeweils eine Zeile pro Code."
                    />
                </FormSectionContent>
            </Form>
            <span onClick={() => navigate(-1)}
                  className="cursor-pointer float-right mt-2 font-medium text-imsblue-600">Zurück</span>
        </NarrowPage>
    );
}
